import axiosWithoutInterceptor from 'axios';
import * as actions from './actionTypes';
import { setLoading, setMessage } from './general';
import axios from '../../config/axiosInstance';

export const fetchStates = countryCod => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(`/static/locations/country/${countryCod}`, { headers: null })
    .then((response) => {
      dispatch(fetchStatesSuccess(response.data));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const fetchStatesSuccess = data => ({
  type: actions.FETCH_STATES_SUCCESS,
  data,
});


export const fetchCities = stateCod => (dispatch) => {
  dispatch(setLoading(true));
  axios
    .get(`/static/locations/state/${stateCod}`)
    .then((response) => {
      dispatch(fetchCitiesSuccess(response.data));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const fetchCitiesSuccess = data => ({
  type: actions.FETCH_CITIES_SUCCESS,
  data,
});

export const fetchAddress = cep => (dispatch) => {
  dispatch(setLoading(true));
  axiosWithoutInterceptor
    .get(`https://viacep.com.br/ws/${cep}/json/`)
    .then((response) => {
      response.data.erro ? dispatch(setMessage('CEP não encontrado')) : dispatch(fetchAddressSuccess(response.data));
      dispatch(setLoading(false));
    })
    .catch((error) => {
      dispatch(setLoading(false));
      dispatch(setMessage(error));
    });
};

export const fetchAddressSuccess = data => ({
  type: actions.FETCH_ADDRESS_SUCCESS,
  data,
});
